import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { updateTimeFormat } from "../../config/ConfigSlice";

const twelveFormat = "hh:mm a";
const twentyFourFormat = "HH:mm";

function TimeFormatCheckbox() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const timeFormat = useAppSelector(
    (state) => state.config.components.timeFormat
  );
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);

  const onChange = () => {
    const format = timeFormat.startsWith("HH")
      ? twelveFormat
      : twentyFourFormat;
    dispatch(updateTimeFormat(format));
    try {
      localStorage.setItem("time-format", format);
    } catch (err) {
      console.warn("Cannot access local store", err);
    }
  };

  useEffect(() => {
    try {
      const timeFormat = localStorage.getItem("time-format");
      if (timeFormat) {
        dispatch(updateTimeFormat(timeFormat));
      }
    } catch (err) {
      console.warn("Cannot access local store", err);
    }
  }, [dispatch]);

  return (
    <div className="field">
      <div className="control">
        <label className="checkbox" title={t("TWENTY_FOUR_HOUR_FORMAT")}>
          <input
            type="checkbox"
            checked={timeFormat.startsWith("HH")}
            disabled={disabled}
            onChange={onChange}
          />
          {t("TWENTY_FOUR_HOUR_FORMAT")}
        </label>
      </div>
    </div>
  );
}

export default TimeFormatCheckbox;
